module.exports = __webpack_public_path__ + "static/img/cj0.d7d4227.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cj0.jpeg
// module id = cicC
// module chunks = 0